import { render, staticRenderFns } from "./TradingOrdersExtra.vue?vue&type=template&id=fb34fd32&scoped=true&"
import script from "./TradingOrdersExtra.vue?vue&type=script&lang=js&"
export * from "./TradingOrdersExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb34fd32",
  null
  
)

export default component.exports